"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _styleUtilities = require("@creditas-lab/style-utilities");

var _stylitas = require("@creditas/stylitas");

const Container = _stylitas.styled.div`
  display: flex;
  flex: 1;
  padding: 12px 20px 24px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  scroll-behavior: smooth;

  & > * {
    height: 100%;
  }

  ${_styleUtilities.media.md`
    padding: 32px 48px 48px;
  `}
`;
exports.Container = Container;